import { SpeechAuthor } from '@components/articles/InterviewWithHeadHR/styles'
import { AppRoutes } from '@constants/app-routes'
import { theme } from '@theme'
import { PostConfig } from '@ui/article/ArticleGenerator/types'
import { OrangeLink } from '@ui/links/OrangeLink'

import { FormTitle, HeaderTitleWrapper, OrangeSpan } from './styles'

const baseURL = '/images/articles/modsen-wrapping-up-2023-with-cto'

export const mobileHeaderProps = {
  imagePath: `${baseURL}/bg_mobile.webp`,
  bottom: '5%',
}

export const mobileEmailFormProps = {
  title: (
    <FormTitle>
      Stay Tuned{'\n'}You have free access to articles, guides, useful tips, and
      industry insights from our experts
    </FormTitle>
  ),
}

export const config: PostConfig = {
  pageUniqId: 'WrappingUp2023WithCTO',
  headerProps: {
    imagePath: `${baseURL}/bg.webp`,
    imageTitle: "Modsen's CTO interview",
    imageAlt: "Modsen's CTO interview",
    title: (
      <HeaderTitleWrapper>
        Reflecting on 2023: <OrangeSpan>Modsen’s CTO</OrangeSpan> on tech
        frontiers, resilient teams, and future vision
      </HeaderTitleWrapper>
    ),
    titleWidth: '750px',
    titleTransform: '29%',
    position: '95%',
    bottom: '15%',
    hexagonLeft: false,
    hexagonRight: false,
    hexagonLeftPosition: '0%',
    hexagonRightPosition: '0%',
    overlay: true,
  },
  emailFormProps: {
    title: (
      <FormTitle>
        Stay Tuned{'\n'}You have free access to articles, guides, useful tips,
        and industry{'\n'}insights from our experts
      </FormTitle>
    ),
    titleSubmited: '\nThanks, we’ve got it!',
    imageDetail: {
      path: '/images/email-subscription-blog.svg',
      width: 232,
      height: 230,
    },
    imageDetailSubmited: {
      path: '/images/stay-tuned-submited.webp',
      width: 232,
      height: 193,
    },
    marginTop: '0',
  },
  article: [
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Interviewer:</SpeechAuthor> Greetings! Thank you for
          taking the time to meet with us! This year has brought significant
          events, both for you and the entire company. You’ve recently become
          Modsen’s technical director. Could you share how this change has
          impacted your life?
        </>
      ),
      marginTop: `0`,
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Eugene:</SpeechAuthor> Hey there, thanks for having me!
          Becoming technical director at Modsen has been a defining transition.
          Life’s definitely gotten more engaging and exciting. It’s less about a
          major upheaval and more about taking what’s already great about our
          tech scene and giving it an extra boost. Stepping into this role means
          diving deeper into refining our tech strategies, pushing innovation
          boundaries, and increasing our input and impact within the scope of
          Modsen’s projects.
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Interviewer:</SpeechAuthor> Speaking about global
          changes, 2023 tested the entire IT community with mass layoffs,
          bankruptcy of large startups, etc. Despite this, Modsen continues to
          grow its staff of technical specialists, open new departments, and
          expand its partner base. What’s the secret?
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Eugene:</SpeechAuthor> In response to your question,
          it’s hard to ignore the similarities between the complexities of
          business and the precision found in exact sciences. You see, in
          mathematics, formulas can be represented as a fraction, where our
          success, knowledge, and experience form the numerator, and the
          adversities we face become the denominator. This year, significant
          variables joined the denominator, posing considerable challenges. My
          role revolves around devising strategies to minimize these factors,
          essentially bolstering the numerator and reducing the denominator’s
          impact or transforming its variables into a margin of error.
        </>
      ),
    },
    {
      type: 'paragraph',
      value:
        'We maintain an unwavering vigilance, keeping a keen eye on global events. This proactive stance allows us to foresee shifts, swiftly adapt, and transform potential setbacks into opportunities for growth.',
    },
    {
      type: 'image',
      value: {
        src: `${baseURL}/cto-1.webp`,
        title: 'Eugene Kalugin',
        alt: 'Eugene Kalugin',
        width: 2620,
        height: 1776,
        quality: 100,
      },
      marginTop: `${theme.newSpaces.md}px`,
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Interviewer:</SpeechAuthor> Modsen is known for leading
          the way in advanced technologies. Do you have any exciting
          developments or endeavors to share? How active has this year been for
          you in terms of project involvement?
        </>
      ),
      marginTop: `${theme.newSpaces.md}px`,
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Eugene:</SpeechAuthor> Well, project diversity has been
          incredibly exciting this year. Alongside our core focus areas such as
          web and server development, we’ve delved into highly fruitful ventures
          in AI, ML, and crypto. These forays have not only deepened our
          expertise but also reinforced our commitment to pioneering
          technologies. Regarding the busyness, it’s a bit tricky to put a
          number on it. At Modsen, we invest ourselves deeply into every
          project, striving to make each one exceptional.
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Interviewer:</SpeechAuthor> Are there any specific
          business areas that interest you as a professional?
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Eugene:</SpeechAuthor> While our core expertise lies in
          fintech, medtech, and logistics, we’re genuinely open and enthusiastic
          about exploring various other business domains. As professionals,
          we’re adaptable and keen on embracing new challenges across diverse
          sectors.
        </>
      ),
    },
    {
      type: 'image',
      value: {
        src: `${baseURL}/cto-2.webp`,
        title: "Modsen's CTO",
        alt: "Modsen's CTO",
        width: 2620,
        height: 1776,
        quality: 100,
      },
      marginTop: `${theme.newSpaces.md}px`,
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Interviewer:</SpeechAuthor> Amidst Modsen's diverse
          fintech projects, what hurdles does this domain face today? How might
          proficient tech firms aid in overcoming these challenges?
        </>
      ),
      marginTop: `${theme.newSpaces.md}px`,
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Eugene:</SpeechAuthor> Similar to many sectors, fintech
          encounters its share of challenges. One persistent issue revolves
          around sourcing technically adept engineers—a challenge that we, at
          Modsen, have been effectively managing. Our team provides our clients
          with top-notch expertise and support from seasoned software
          developers. By ensuring a robust talent pool and fostering an
          environment that nurtures tech excellence, we’re adept at tackling the
          demands of the ever-evolving fintech landscape.
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Interviewer:</SpeechAuthor> Nowadays, it seems like AI
          is the talk of the town. How do you evaluate this trend? Do clients
          frequently inquire about developing AI applications?
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Eugene:</SpeechAuthor> Absolutely, AI has become
          pervasive across nearly every industry, and it’s becoming a necessity
          rather than a luxury. At Modsen, we regularly receive requests to
          develop AI applications, reflecting the growing need for innovative
          solutions powered by artificial intelligence to address complex
          challenges and enhance operational efficiency across diverse fields.
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Interviewer:</SpeechAuthor> Beyond the current
          technological focus, what other pioneering advancements is Modsen
          eyeing for implementation in the upcoming year?
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Eugene:</SpeechAuthor> We’re actively exploring a range
          of cutting-edge technologies. Our attention remains dedicated to
          further advancements in AI and ML, as they continue to evolve and
          offer immense potential. Additionally, we’re deeply engaged in
          exploring the realms of crypto tech, data engineering, and even
          venturing into hardware-related innovations. These technological
          frontiers align with our commitment to staying at the forefront of
          innovation, ensuring that we’re prepared to meet the dynamic needs of
          our clients.
        </>
      ),
    },
    {
      type: 'image',
      value: {
        src: `${baseURL}/cto-3.webp`,
        title: 'CTO',
        alt: 'CTO',
        width: 2620,
        height: 1776,
      },
      marginTop: `${theme.newSpaces.md}px`,
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Interviewer:</SpeechAuthor> Alright, let’s put on our
          futurologist hats now. What’s the next big tech phenomenon on the
          horizon? Any under-the-radar areas, akin to AI’s rise, that you find
          promising and worth keeping an eye on?
        </>
      ),
      marginTop: `${theme.newSpaces.md}px`,
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Eugene:</SpeechAuthor> There’s certainly something on
          the horizon that has caught our attention, and we’re diligently
          tracking and nurturing its development within our initiatives.
          However, I hope you understand, it's not the right time to divulge
          specifics just yet.
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Interviewer:</SpeechAuthor> And what in the IT world is
          timeless, never going out of fashion?
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Eugene:</SpeechAuthor> The ability to think critically
          and innovatively.
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Interviewer:</SpeechAuthor> But a technical director is,
          of course, not only about technology. How do you blend your technical
          expertise with your role as a leader and mentor within the team?
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Eugene:</SpeechAuthor> In fact, technical expertise lays
          a strong foundation. For me, it’s not about compartmentalizing these
          roles; instead, I see them as integral parts of a unified whole.
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Interviewer:</SpeechAuthor> Regarding team dynamics, are
          there specialized groups at Modsen adept at addressing specific
          business challenges for clients?
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Eugene:</SpeechAuthor> Indeed, this aspect holds
          considerable importance for us. Our team structure prioritizes the
          formation and nurturing of specialized groups adept at addressing the
          diverse business challenges our clients encounter. Coordinating these
          teams effectively is our priority, ensuring they possess the
          specialized skills and strong collaboration necessary to deliver
          tailored solutions for our clients’ intricate and varied business
          needs.
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Interviewer:</SpeechAuthor> What strategies do you
          employ to maintain your team’s resilience and motivation during
          challenging or stressful periods?
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Eugene:</SpeechAuthor> Staying focused on the outcome is
          key. In challenging times, obstacles, you know, are just mere
          variables in the larger equation I mentioned earlier.
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Interviewer:</SpeechAuthor> Any advice for aspiring
          leaders, particularly in the tech industry, on balancing personal
          well-being and achieving career success?
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Eugene:</SpeechAuthor> Family stands at the core of
          everything.
        </>
      ),
    },
    {
      type: 'image',
      value: {
        src: `${baseURL}/cto-4.webp`,
        title: "Modsen's interview",
        alt: "Modsen's interview",
        width: 2620,
        height: 1776,
      },
      marginTop: `${theme.newSpaces.md}px`,
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Interviewer:</SpeechAuthor> With the Modsen team being
          expansive and working globally, what message would you like to share
          with your colleagues as this year comes to an end?
        </>
      ),
      marginTop: `${theme.newSpaces.md}px`,
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Eugene:</SpeechAuthor> In short, a huge THANK YOU,
          everyone! Each of you is a cornerstone in our global journey{' '}
          <OrangeLink inherit href={AppRoutes.partnership} target="_blank">
            at Modsen.
          </OrangeLink>{' '}
          Let’s appreciate the hurdles conquered and triumphs gained, vital
          elements of our success. Grateful for your relentless dedication,
          eagerly looking forward to more achievements together. Here’s to our
          fantastic team!
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Interviewer:</SpeechAuthor> Eugene, thank you very much
          for the conversation. It’s always a pleasure to converse with you.
          Wishing you all the best in the coming year!
        </>
      ),
    },
    {
      type: 'paragraph',
      value: (
        <>
          <SpeechAuthor>Eugene:</SpeechAuthor> Thank you sincerely for the
          engaging conversation, the pleasure is mutual.
        </>
      ),
    },
  ],
}
